import React, {
  useState,
  useRef,
  useMemo,
  useCallback,
  useEffect,
} from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import {
  getUserProfile,
  adminUpdateStatus,
  adminGetUsers,
  adminNoticiation,
} from "../../../config/service";
import UpdateDetails from "./UpdateDetails";
import { Button } from "react-bootstrap";
import moment from "moment";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Report from "./Report";
import { RotatingLines } from "react-loader-spinner";
import { formattedDate } from "../../../utils/function";

const serverOnlySortComparator = () => 0;

/** Maps AG Grid colId → admin getUsers API sortField */
const USER_GRID_COL_TO_SORT = {
  "Physician/Client Name": "name",
  Email: "email",
  "Phone Number": "phone",
  Id: "id",
  Doctor_ClientId: "doctorClientId",
  Role: "role",
  createdAt: "createdAt",
};

const USER_SORT_TO_GRID_COL = {
  name: "Physician/Client Name",
  email: "Email",
  phone: "Phone Number",
  id: "Id",
  doctorClientId: "Doctor_ClientId",
  role: "Role",
  createdAt: "createdAt",
};

const USER_LIST_DEFAULT_SORT = { sortField: "createdAt", sortDir: -1 };

// headers for search functionality (+ optional server-sort control from AG Grid)
const SearchHeader = (props) => {
  const {
    field,
    columnSearchRef,
    onSearch,
    fieldLabel,
    searchNonce,
    enableSorting,
    progressSort,
    column,
  } = props;
  const [localValue, setLocalValue] = useState(columnSearchRef.current[field] || "");

  useEffect(() => {
    setLocalValue(columnSearchRef.current[field] || "");
  }, [searchNonce, field, columnSearchRef]);

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setLocalValue(newValue);
    columnSearchRef.current[field] = newValue;
  };

  const handleSearch = () => {
    onSearch({ ...columnSearchRef.current });
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const sort = column?.getSort?.();

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 4,
          fontWeight: "bold",
          marginBottom: "4px",
        }}
      >
        {enableSorting && progressSort ? (
          <button
            type="button"
            title="Sort"
            onClick={(e) => {
              e.stopPropagation();
              progressSort(e.shiftKey);
            }}
            style={{
              border: "none",
              background: "transparent",
              cursor: "pointer",
              padding: "0 2px",
              fontSize: "10px",
              lineHeight: 1,
            }}
          >
            {sort === "asc" ? "▲" : sort === "desc" ? "▼" : "↕"}
          </button>
        ) : null}
        <span>{fieldLabel}</span>
      </div>
      <div style={{ display: "flex" }}>
        <input
          type="text"
          value={localValue}
          placeholder="חיפוש..."
          style={field === "Id" ? { width: "80px" } : field === "Role" ? { width: "60px" } : {}}
          onChange={handleInputChange}
          onKeyPress={handleKeyPress}
        />
        <button onClick={handleSearch}>🔍</button>
      </div>
    </div>
  );
};

const UserTable = () => {
  const gridRef = useRef();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [allUser, setAllUser] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [updateId, setUpdateId] = useState();
  const [updateModal, setUpdateModal] = useState(false);
  const [userdata, setuserdata] = useState();
  const [selectedValue, setSelectedValue] = useState([]);
  const [connectedUsers, setConnectedUsers] = useState([]);
  const [selectedDoctorId, setSelectDoctorId] = useState([]);
  const [selectedSecretaryId, setSelectSecretaryId] = useState([]);
  const [id, setSelectId] = useState([]);
  const [doctorId, setDoctorId] = useState();
  const [value, setDOB] = useState(new Date());
  const [selectedtype, setSelectedType] = useState([]);
  const [selectedSubscriptions, setSelectedSubscriptions] = useState([]);
  const [reportModal, setReportModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [calenderInvite, setCalenderInvite] = useState(true);
  const initialUsersRef = useRef(null);
  const shouldFetchRef = useRef(true);
  const [profileData, setProfileData] = useState();
  const [profileLoading, setProfileLoading] = useState(true);

  const itemsPerPage = 10;
  const gridApi = useRef(null);
  const gridColumnApi = useRef(null);
  const [listSort, setListSort] = useState(() => ({ ...USER_LIST_DEFAULT_SORT }));
  const listSortRef = useRef(listSort);
  listSortRef.current = listSort;
  const getUsersRef = useRef(null);

  const initialSearchFields = {
    "Physician/Client Name": "",
    Email: "",
    "Phone Number": "",
    Id: "",
    "Doctor/Client Id": "",
    Role: "",
    "Doctor Expertise": "",
  };

  const columnSearchRef = useRef({ ...initialSearchFields });
  const [searchNonce, setSearchNonce] = useState(0);

  const handleClose = () => {
    setUpdateModal(false);
    getUsers();
  };

  const handleReportModalClose = () => setReportModal(false);

  const handleSearchUpdate = useCallback((updatedSearch) => {
    columnSearchRef.current = { ...columnSearchRef.current, ...updatedSearch };
    setCurrentPage(1);
    setSearchNonce((n) => n + 1);
  }, []);

  const handleResetSearch = () => {
    Object.keys(initialSearchFields).forEach((key) => {
      columnSearchRef.current[key] = "";
    });

    if (initialUsersRef.current) {
      shouldFetchRef.current = false;
      setAllUser(initialUsersRef.current.users);
      setTotalCount(initialUsersRef.current.total);
    }

    setCurrentPage(1);
    setSearchNonce((n) => n + 1);
  };

  const searchHeaderParams = useMemo(
    () => ({
      columnSearchRef,
      onSearch: handleSearchUpdate,
      searchNonce,
    }),
    [handleSearchUpdate, searchNonce]
  );

  const getColumnDefs = useCallback(
    (screenWidth) => [
    {
      field: "Physician/Client Name",
      headerName: "Name",
      width: screenWidth <= 991 ? 140 : "auto",
      sortable: true,
      comparator: serverOnlySortComparator,
      headerComponent: SearchHeader,
      headerComponentParams: {
        ...searchHeaderParams,
        field: "Physician/Client Name",
        fieldLabel: "Name",
      },
    },
    {
      field: "Email",
      width: screenWidth <= 991 ? 140 : "auto",
      sortable: true,
      comparator: serverOnlySortComparator,
      headerComponent: SearchHeader,
      headerComponentParams: {
        ...searchHeaderParams,
        field: "Email",
        fieldLabel: "Email",
      },
    },
    {
      field: "Phone Number",
      width: screenWidth <= 991 ? 140 : "auto",
      sortable: true,
      comparator: serverOnlySortComparator,
      headerComponent: SearchHeader,
      headerComponentParams: {
        ...searchHeaderParams,
        field: "Phone Number",
        fieldLabel: "Phone",
      },
    },
    {
      field: "Id",
      width: 120,
      sortable: true,
      comparator: serverOnlySortComparator,
      headerComponent: SearchHeader,
      headerComponentParams: {
        ...searchHeaderParams,
        field: "Id",
        fieldLabel: "ID",
      },
    },
    {
      headerName: "Doctor/Client Id",
      field: "Doctor_ClientId",
      width: screenWidth <= 991 ? 140 : "auto",
      sortable: true,
      comparator: serverOnlySortComparator,
      headerComponent: SearchHeader,
      headerComponentParams: {
        ...searchHeaderParams,
        field: "Doctor/Client Id",
        fieldLabel: "Doctor/Client ID",
      },
    },
    {
      field: "Role",
      width: screenWidth <= 991 ? 80 : 100,
      sortable: true,
      comparator: serverOnlySortComparator,
      headerComponent: SearchHeader,
      headerComponentParams: {
        ...searchHeaderParams,
        field: "Role",
        fieldLabel: "Role",
      },
    },
    {
      headerName: "Doctor Expertise",
      field: "Doctor_expertise",
      width: screenWidth <= 991 ? 140 : "auto",
      sortable: false,
      headerComponent: SearchHeader,
      headerComponentParams: {
        ...searchHeaderParams,
        field: "Doctor Expertise",
        fieldLabel: "Expertise",
      },
    },
    {
      field: "Action",
      sortable: false,
      width: screenWidth <= 991 ? 100 : 120,
      pinned: screenWidth <= 991 ? "right" : null,
      cellRendererFramework: (params) => (
        <div>
          <Button
            onClick={() =>
              Update(
                params.data.Doctor_ClientId,
                params.data.data.croppedAvatar,
                params.data.data
              )
            }
          >
            Update
          </Button>
        </div>
      ),
    },
    {
      field: "Active/Deactive",
      sortable: false,
      width: 140,
      valueGetter: (params) => {
        if (params.data.Role === "doctor") {
          return params.data.isActive ? "Active" : "Pending";
        }
        return "";
      },
      cellRendererFramework: (params) => (
        <div>
          {params.data.Role === "doctor" ? (
            <select
              onChange={(e) =>
                handleChangeactive(e, params.data.Doctor_ClientId)
              }
              defaultValue={params.data.isActive ? "Active" : "Pending"}
              className="form-control status-text"
            >
              <option value="Pending">Pending</option>
              <option value="Active">Active</option>
            </select>
          ) : null}
        </div>
      ),
    },
    {
      field: "createdAt",
      headerName: "Registration date",
      sort: "desc",
      sortable: true,
      comparator: serverOnlySortComparator,
      valueFormatter: (params) => {
        const { role, createdAt } = params.data.data || {};

        if (role === "doctor") {
          return formattedDate(createdAt);
        }

        return "";
      },
    },
    {
      field: "Notification",
      sortable: false,
      width: 110,
      cellRendererFramework: (params) => (
        <div>
          {params.data.Role === "doctor" ? (
            <input
              type="checkbox"
              defaultChecked={params.data.data?.doctorPersonalData?.isNotification}
              onChange={(e) =>
                handleNotifcation(params.data.Doctor_ClientId, e.target.checked)
              }
              className="notificationcheck"
            />
          ) : null}
        </div>
      ),
    },
  ],
    [searchHeaderParams]
  );

  const [columnDefs, setColumnDefs] = useState(() => getColumnDefs(window.innerWidth));

  useEffect(() => {
    const handleResize = () => {
      setColumnDefs(getColumnDefs(window.innerWidth));
    };

    // Initial setting of column definitions
    setColumnDefs(getColumnDefs(window.innerWidth));

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [getColumnDefs]);

  const handleNotifcation = async (id, flag) => {
    const data = {
      isNotification: flag,
      doctorUserId: id,
    };
    const response = await adminNoticiation(data);
    toast.success(t(response.data.message));
    getUsers();
  };

  const userDetails = async (id) => {
    try {
      setProfileLoading(true);
      const response = await getUserProfile({ userId: id });
      if ([200, 201, 202].includes(response.status)) {
        setProfileData(response.data.profileDetails[0]);
        setDoctorId(response.data.profileDetails[0]._id);
        setDOB(
          response.data?.profileDetails[0]?.clientDOB ?
            moment(response.data?.profileDetails[0]?.clientDOB).toDate() : null
        );
      }
      if (response.data.statusCode === 401) {
        localStorage.removeItem("token");
        navigate("/login");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setProfileLoading(false);
    }
  };

  const handleChangeactive = async (e, id) => {
    try {
      let data = {
        isActive: e.target.value == "Active" ? true : false,
        doctorId: id,
      };

      const response = await adminUpdateStatus(data);
      if ([200, 201, 203].includes(response.status)) {
        toast.success(t(response.data.message));
        getUsers();
      } else {
        toast.error(t(response.data.msg));
      }
    }
    catch (error) {
      console.log(error);
    }
  };

  const Update = (id, url, data) => {
    setUpdateId(id);
    setUpdateModal(true);
    userDetails(id);
    setuserdata(data);
    setCalenderInvite(data?.doctorPersonalData?.sendCalendarInvite);
    if (data.role === "doctor") {
      setSelectedValue(data?.consultation);
      setSelectId(data?.consultation.map((d) => d._id));
      setSelectedType(data?.doctorPersonalData?.patientsCategory.map((d) => ({
        eng: d,
        heb: d === "Children" ? "ילד.ה" : "מבוגר"
      })));
      setSelectedSubscriptions(data?.doctorPersonalData?.subscriptions);
    } else {
      setSelectedValue([]);
      setSelectId([]);
      setSelectedType([]);
      setSelectedSubscriptions([]);
    }
  };

  const defaultColDef = useMemo(
    () => ({
      sortable: false,
      filter: false,
      editable: true,
      resizable: true,
      floatingFilter: false,
      width: "auto",
    }),
    []
  );

  const handleUserSortChanged = useCallback((event) => {
    const columnState =
      typeof event?.columnApi?.getColumnState === "function"
        ? event.columnApi.getColumnState()
        : [];
    const cols = columnState.filter((c) => c.sort != null);
    if (cols.length === 0) {
      setListSort((prev) =>
        prev.sortField === USER_LIST_DEFAULT_SORT.sortField &&
        prev.sortDir === USER_LIST_DEFAULT_SORT.sortDir
          ? prev
          : { ...USER_LIST_DEFAULT_SORT }
      );
      return;
    }
    const primary = [...cols].sort(
      (a, b) => (a.sortIndex ?? 0) - (b.sortIndex ?? 0)
    )[0];
    const apiField = USER_GRID_COL_TO_SORT[primary.colId];
    if (!apiField) return;
    const sortDir = primary.sort === "asc" ? 1 : -1;
    setListSort((prev) =>
      prev.sortField === apiField && prev.sortDir === sortDir
        ? prev
        : { sortField: apiField, sortDir }
    );
  }, []);

  const cellClickedListener = useCallback((event) => {
    console.log("cellClicked", event);
  }, []);

  const getUsers = useCallback(async (page = 1, searchObj = columnSearchRef.current) => {
    setLoading(true);
    try {
      const ls = listSortRef.current;
      const data = {
        page,
        perPage: itemsPerPage,
        sortField: ls.sortField,
        sortDir: ls.sortDir,
        searchFields: {
          name: searchObj["Physician/Client Name"] || "",
          email: searchObj["Email"] || "",
          phone: searchObj["Phone Number"] || "",
          id: searchObj["Id"] || "",
          doctorClientId: searchObj["Doctor/Client Id"] || "",
          role: searchObj["Role"] || "",
          expertise: searchObj["Doctor Expertise"] || ""
        }
      };

      const response = await adminGetUsers(data);

      const formattedUsers = response.data.user.map((d) => ({
        "Physician/Client Name": `${d.first_name} ${d.last_name}`,
        Email: d.email,
        "Phone Number": d.phone,
        Id: d.id,
        Doctor_ClientId: d._id,
        data: d,
        Role: d.role,
        isActive: d?.doctorPersonalData?.isActive,
        Doctor_expertise:
          d?.consultation && d?.consultation.length !== 0
            ? d?.consultation.map((d2) => d2.heb)
            : null,
      }));

      setAllUser(formattedUsers);
      setTotalCount(response.data.totalCount);

      if (!initialUsersRef.current) {
        initialUsersRef.current = {
          users: formattedUsers,
          total: response.data.totalCount,
        };
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  }, [itemsPerPage]);

  getUsersRef.current = getUsers;

  useEffect(() => {
    if (!shouldFetchRef.current) {
      shouldFetchRef.current = true;
      return;
    }
    getUsers(currentPage);
  }, [currentPage, searchNonce, getUsers]);

  const userSortSkipInitialRef = useRef(true);
  useEffect(() => {
    if (userSortSkipInitialRef.current) {
      userSortSkipInitialRef.current = false;
      return;
    }
    setCurrentPage(1);
    getUsersRef.current?.(1);
  }, [listSort]);

  useEffect(() => {
    const colId = USER_SORT_TO_GRID_COL[listSort.sortField];
    if (!colId || !gridColumnApi.current?.applyColumnState) return;
    const sort = listSort.sortDir === 1 ? "asc" : "desc";
    gridColumnApi.current.applyColumnState({
      state: [{ colId, sort, sortIndex: 0 }],
      defaultState: { sort: null },
    });
  }, [listSort]);

  const onGridReady = useCallback((params) => {
    gridApi.current = params.api;
    gridColumnApi.current = params.columnApi;
    const ls = listSortRef.current;
    const colId = USER_SORT_TO_GRID_COL[ls.sortField];
    if (colId && params.columnApi?.applyColumnState) {
      params.columnApi.applyColumnState({
        state: [
          {
            colId,
            sort: ls.sortDir === 1 ? "asc" : "desc",
            sortIndex: 0,
          },
        ],
        defaultState: { sort: null },
      });
    }
  }, []);

  const onExportClick = useCallback(() => {
    if (!gridApi.current) return;
    const formattedDateStr = moment().format("DD-MM-YYYY HH-mm-ss");
    gridApi.current.exportDataAsCsv({
      fileName: `user-export-${formattedDateStr}.csv`
    });
  }, []);

  const onExportAllClick = useCallback(async () => {
    try {
      const perPage = totalCount && totalCount > 0 ? totalCount : 1000000;

      const data = {
        page: 1,
        perPage,
        sortField: listSort.sortField,
        sortDir: listSort.sortDir,
        searchFields: {
          name: columnSearchRef.current["Physician/Client Name"] || "",
          email: columnSearchRef.current["Email"] || "",
          phone: columnSearchRef.current["Phone Number"] || "",
          id: columnSearchRef.current["Id"] || "",
          doctorClientId: columnSearchRef.current["Doctor/Client Id"] || "",
          role: columnSearchRef.current["Role"] || "",
          expertise: columnSearchRef.current["Doctor Expertise"] || ""
        }
      };

      const response = await adminGetUsers(data);

      const fullRows = (response.data.user || []).map((d) => ({
        "Physician/Client Name": `${d.first_name} ${d.last_name}`,
        Email: d.email,
        "Phone Number": d.phone,
        Id: d.id,
        Doctor_ClientId: d._id,
        data: d,
        Role: d.role,
        isActive: d?.doctorPersonalData?.isActive,
        Doctor_expertise:
          d?.consultation && d?.consultation.length
            ? d.consultation.map((c) => c.heb)
            : null,
      }));

      if (!gridApi.current) return;
      const api = gridApi.current;

      const prevData = allUser;
      api.setRowData(fullRows);

      api.exportDataAsCsv({
        fileName: `user-export-all-${moment().format("DD-MM-YYYY HH-mm-ss")}.csv`,
        allColumns: true
      });

      api.setRowData(prevData);
    } catch (err) {
      console.error(err);
      toast.error(t("Export failed"));
    }
  }, [totalCount, allUser, t, listSort]);

  return (
    <div className="user-mangement-page">
      <div className="container-fluid">
        {reportModal && <Report handleReportModalClose={handleReportModalClose} reportModal={reportModal} />}
        {updateModal && (
          <UpdateDetails
            userdata={userdata}
            updateId={updateId}
            updateModal={updateModal}
            selectedValue={selectedValue}
            id={id}
            doctorId={doctorId}
            value={value}
            setDOB={setDOB}
            setUpdateModal={setUpdateModal}
            setSelectedValue={setSelectedValue}
            setSelectId={setSelectId}
            handleClose={handleClose}
            selectedtype={selectedtype}
            selectedSubscriptions={selectedSubscriptions}
            setSelectedSubscriptions={setSelectedSubscriptions}
            setSelectedType={setSelectedType}
            setCalenderInvite={setCalenderInvite}
            calenderInvite={calenderInvite}
            connectedUsers={connectedUsers}
            setConnectedUsers={setConnectedUsers}
            setSelectDoctorId={setSelectDoctorId}
            selectedDoctorId={selectedDoctorId}
            setSelectSecretaryId={setSelectSecretaryId}
            selectedSecretaryId={selectedSecretaryId}
            profileData={profileData}
            profileLoading={profileLoading}
          />
        )}

        <div className="ag-theme-alpine" style={{ height: 630 }}>
          <div className="mb-2 d-flex flex-row align-items-center">
            <Button onClick={onExportClick} className="download_report">
              Export current page to CSV
            </Button>
            <Button onClick={onExportAllClick} className="download_report ms-2">
              Export all data to CSV
            </Button>
            <Button
              className="ms-2 me-auto"
              onClick={handleResetSearch}
            >
              Clear search
            </Button>
          </div>

          {loading ? (
            <div className="d-flex justify-content-center align-items-center" style={{ width: "100%", height: "100%" }}>
              <RotatingLines strokeColor="grey" strokeWidth="5" animationDuration="0.75" width="64" visible={true} />
            </div>
          ) : (
            <>
              <AgGridReact
                ref={gridRef}
                rowData={allUser}
                gridOptions={{
                  rowHeight: 60,
                  groupHeaderHeight: 60,
                  headerHeight: 60,
                  suppressMultiSort: true,
                }}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                animateRows={true}
                rowSelection="multiple"
                onCellClicked={cellClickedListener}
                alwaysShowHorizontalScroll={true}
                alwaysShowVerticalScroll={true}
                onGridReady={onGridReady}
                onSortChanged={handleUserSortChanged}
              />
              {(allUser.length) > 0 && (
                <div className="d-flex justify-content-center mt-3">
                  <Button
                    variant="secondary"
                    onClick={() => {
                      const prevPage = Math.max(currentPage - 1, 1);
                      setCurrentPage(prevPage);
                    }}
                    disabled={currentPage === 1}
                    className="me-2"
                  >
                    הקודם
                  </Button>

                  <span style={{ lineHeight: "38px", margin: "0 16px" }}>
                    עמוד {currentPage} מתוך {Math.ceil(totalCount / itemsPerPage)}
                  </span>

                  <Button
                    variant="secondary"
                    onClick={() => {
                      const nextPage = currentPage + 1;
                      setCurrentPage(nextPage);
                    }}
                    disabled={currentPage === Math.ceil(totalCount / itemsPerPage)}
                    className="ms-2"
                  >
                    הבא
                  </Button>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserTable;